export default __webpack_public_path__ + "static/media/Artwork_gmx.ffa2c472.svg";